module.exports = __webpack_public_path__ + "static/media/prediction.2e06c294.gif";